import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/product-sample-storage.jpg'),
    alt: 'product sample storage og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'product sample storage search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Product Sample <span>Storage</span> <span>For Your Business Needs</span',
  description:
    'Are you struggling to find a secure, organized space for your product samples? ShipAndStorage offers premium product sample storage services designed to keep your items safe, accessible, and in pristine condition',
  image: {
    url: '/images/v2/pages/main-pages/product-sample-storage/hero-image.jpg',
    alt: 'product-sample-storage'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Secure Your Samples' }
}

export const whyWeSectionContent = {
  title: 'How Our Product Sample Storage Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started with Storage' },
  cards: [
    {
      id: 1,
      title: 'Easy Registration',
      description: 'Start by creating an account and choosing a storage plan that meets your needs.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/easy-registration.svg',
        alt: 'Easy Registration'
      }
    },
    {
      id: 2,
      title: 'Secure Pickup Services',
      description: 'Schedule a pickup, and we’ll safely transport your samples to our facility.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/secure-pickup-services.svg',
        alt: 'Secure Pickup Services'
      }
    },
    {
      id: 3,
      title: 'Organized Storage',
      description: 'Each item is cataloged and stored for easy retrieval, ensuring never lose the track.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/organized-storage.svg',
        alt: 'Organized Storage'
      }
    },
    {
      id: 4,
      title: 'Flexible Delivery Options',
      description: 'Need your samples back? Request delivery to your location or event.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/flexible-delivery-options.svg',
        alt: 'Flexible Delivery Options'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Choose Us for Product Sample Storage?',

  cards: [
    {
      id: 1,
      title: 'Secure and Specialized Storage',
      description:
        'Store your product samples in clean, secure, and climate-controlled facilities designed to protect their quality.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/secure-and-specialized-storage.svg',
        alt: 'Secure and Specialized Storage'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Plans',
      description:
        'Choose from a variety of storage options tailored to short-term or long-term needs based on your business demands.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/flexible-storage-plans.svg',
        alt: 'Flexible Storage Plans'
      }
    },
    {
      id: 3,
      title: 'Easy Access to Your Samples',
      description:
        'Access your samples anytime with our hassle-free retrieval services, making it convenient for your operations.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/easy-access-to-your-samples.svg',
        alt: 'Easy Access to Your Samples'
      }
    },
    {
      id: 4,
      title: 'Top-Notch Security',
      description:
        'Benefit from 24/7 security monitoring, restricted access, and secure handling to ensure your items are always safe.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/top-notch-security.svg',
        alt: 'Top-Notch Security'
      }
    },
    {
      id: 5,
      title: 'Affordable Pricing Options',
      description:
        'Enjoy transparent pricing with no hidden fees, offering cost-effective solutions that fit your budget.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/affordable-pricing-options.svg',
        alt: 'Affordable Pricing Options'
      }
    },
    {
      id: 6,
      title: 'Quick Pickup and Delivery',
      description:
        'Schedule fast pickups and deliveries, so your product samples are where you need them, when you need them.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/quick-pickup-and-delivery.svg',
        alt: 'Quick Pickup and Delivery'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Benefits of Product Sample Storage with ShipAndStorage',

  cards: [
    {
      id: 1,
      title: 'Enhanced Organization',
      description: 'Keep your product samples sorted and ready for presentations, trade shows.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/enhanced-organization.svg',
        alt: 'Enhanced Organization'
      }
    },
    {
      id: 2,
      title: 'Damage Prevention',
      description: 'Protect your items from environmental damage with climate-controlled storage.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/damage-prevention.svg',
        alt: 'Damage Prevention'
      }
    },
    {
      id: 3,
      title: 'Space Optimization',
      description: 'Free up your office or warehouse by storing samples in a dedicated facility.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/space-optimization.svg',
        alt: 'Space Optimization'
      }
    },
    {
      id: 4,
      title: 'Seamless Logistics',
      description: 'Our storage and delivery solutions save time, letting you focus on your business.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/seamless-logistics.svg',
        alt: 'Seamless Logistics'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Ideal Items for Product Sample Storage',

  articles: [
    {
      content: [
        {
          id: 1,
          points: [
            '<strong>Retail Samples</strong></br> Securely store clothing, accessories, and packaged products for retail demos or client pitches.'
          ]
        },
        {
          id: 2,
          points: [
            '<strong>Cosmetic Samples</strong></br> Keep delicate beauty products safe in climate-controlled conditions.'
          ]
        },
        {
          id: 3,
          points: [
            '<strong>Food and Beverage Samples</strong></br>Store non-perishable food or drink samples for marketing campaigns or trade shows.'
          ]
        },
        {
          id: 4,
          points: [
            '<strong>Promotional Materials for Events</strong></br>Safeguard brochures, banners, and giveaway items alongside your product samples.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/ideal-items-for-product-sample-storage.jpg',
        alt: 'Ideal Items for Product Sample Storage'
      }
    }
  ]
}

export const proTipsSectionContent = {
  title: 'Pro Tips for Storing Product Samples',

  cards: [
    {
      id: 1,
      title: 'Organize by Category',
      description: 'Group similar items together to make retrieval faster and more efficient.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/organize-by-category.svg',
        alt: 'Organize by Category'
      }
    },
    {
      id: 2,
      title: 'Label Clearly',
      description: 'Use detailed labels to identify contents easily without opening packages.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/label-clearly.svg',
        alt: 'Label Clearly'
      }
    },
    {
      id: 3,
      title: 'Keep an Inventory',
      description: 'Maintain an updated list of all stored items to track availability and usage.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/keep-an-inventory.svg',
        alt: 'Keep an Inventory'
      }
    },
    {
      id: 4,
      title: 'Use Proper Packaging',
      description: 'Protect items with bubble wrap, foam, or custom boxes to avoid damage.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/use-proper-packaging.svg',
        alt: 'Use Proper Packaging'
      }
    },
    {
      id: 5,
      title: 'Schedule Ahead',
      description: 'Plan storage and delivery requests early to ensure timely access to your samples.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/schedule-ahead.svg',
        alt: 'Schedule Ahead'
      }
    },
    {
      id: 6,
      title: 'Store Promotional Materials',
      description: 'Simplify logistics by keeping related materials like banners and giveaways.',
      image: {
        src: '/images/v2/pages/main-pages/product-sample-storage/store-promotional-materials.svg',
        alt: 'Store Promotional Materials'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Product Sample Storage Solutions for Businesses',
  description:
    'Store your business product samples securely and ship them to multiple locations as needed for your business.',
  image: {
    src: '/images/v2/pages/main-pages/product-sample-storage/promotional-banner-image.svg',
    alt: 'Product Sample Storage Solutions for Businesses'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Book Your Storage' }
}

export const faqSectionContent = {
  title: 'FAQs about Product Sample Storage ',

  questions: [
    {
      id: 1,
      question: 'What types of product samples can I store?',
      answer: 'You can store retail items, cosmetics, food samples, promotional materials, and more.'
    },
    {
      id: 2,
      question: 'Are the storage units climate-controlled?',
      answer: 'Yes, all our units are climate-controlled to protect sensitive items.'
    },
    {
      id: 3,
      question: 'How do I retrieve my product samples?',
      answer: 'Simply schedule a delivery or visit our facility to access your items.'
    },
    {
      id: 4,
      question: 'Is there a minimum storage duration?',
      answer: 'No, we offer flexible plans to accommodate short-term and long-term needs.'
    },
    {
      id: 5,
      question: 'Are there hidden costs in your pricing?',
      answer: 'No, we provide transparent and competitive pricing without additional fees.'
    }
  ]
}
